import {
    greyPalette,
    pastelPalette,
    saturatedPalette
} from "../../helpers/constants/colorPalettes";

export const PAGE_LABELS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const PAGE_COLOR_PALETTES = {
    pastel: [
        pastelPalette.blue,
        pastelPalette.cyan,
        pastelPalette.teal,
        pastelPalette.lime,
        pastelPalette.gold,
        pastelPalette.redOrange,
        pastelPalette.pink,
        pastelPalette.violet,
        pastelPalette.indigo
    ],

    saturated: [
        saturatedPalette.blue,
        saturatedPalette.cyan,
        saturatedPalette.lime,
        saturatedPalette.yellow,
        saturatedPalette.orange,
        saturatedPalette.magenta
    ],

    gray: [
        greyPalette.black,
        greyPalette.darkGrey,
        greyPalette.grey,
        greyPalette.medGrey,
        greyPalette.medLtGrey,
        greyPalette.lightGrey,
        greyPalette.faintGrey,
        greyPalette.white
    ],

    chris: ["#de3d83", "#00b8b8", "#f67944", "#2c7fb8", "#6e7f29", "#e4bd0b"],

    jasmine: ["#00CCFF", "#FF6666", "#33CC99", "#9900CC", "#FF9933", "#FF0066"],

    janet: ["#3949AB", "#03A9F4", "#4CAf50", "#9C27B0", "#FDD835", "#FF0066"],

    default: ["#00CCFF", "#ff8f00", "#0382D7", "#7e57c2", "#fc5f55", "#E4BD0B"]
};



// WEBPACK FOOTER //
// ./src/modules/pages/constants.js